// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 13:39:27
import { ScheduledOpResponse_abstract } from './../abstract/SagaBase/ScheduledOpResponse_abstract';
export class ScheduledOpResponse extends ScheduledOpResponse_abstract {}
